export default __webpack_public_path__ + "static/media/left-side-login.fa1fda29.png";